import { LayoutField } from "./LayoutField";

export class LayoutColumn {
    public Id: string;
    public ColumnSize: number;
    public Hidden: boolean = false;
    public Fields: LayoutField[];
}

